import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';

const LandingPage = () => {
  return (
    <div className="landing-container">
      <div className="landing-content">
        <div className="landing-header">
          <img
            src="/images/clickpay_pay_white.png"
            alt="ClickPay - Secure Payment Gateway"
            className="landing-logo"
          />
          <p>Secure Payment Gateway Solution</p>
        </div>
        
        <div className="user-type-selection">
          
          <div className="portal-cards">
            <div className="portal-card merchant-card">
              <div className="card-icon">
                <i className="fas fa-store"></i>
              </div>
              <h3>Merchant Portal</h3>
              <p>Manage your business payments, transactions, and customer data</p>
              <div className="card-actions">
                <Link to="/merchant/login" className="btn btn-primary">
                  Login
                </Link>
                <Link to="/merchant/signup" className="btn btn-outline">
                  Sign Up
                </Link>
              </div>
            </div>
          </div>
        </div>
        
        <div className="landing-footer">
          <p>&copy; 2024 UPI ClickPay. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;